/* eslint-disable parog-web/no-glint-expect-error-directive */
import { uniqueId } from '@ember/helper';
import Component from '@glimmer/component';
import fuiCheckbox from 'wise-fui-modules/modifiers/fui-checkbox';

interface Signature {
  Args: {
    settings?: Settings;
    label?: string;
    isChecked: boolean;
    type?: 'checkbox' | 'radio' | 'slider' | 'toggle';
  };
}

interface Settings {
  onChange?: (checked: boolean) => unknown;
}

export default class FuiCheckboxComponent extends Component<Signature> {
  get class(): string {
    if (!this.args.type) return 'ui checkbox';

    return this.args.type === 'checkbox'
      ? 'ui checkbox'
      : `ui ${this.args.type} checkbox`;
  }

  get settings(): Settings {
    const settings = this.args.settings || {};
    if (!this.#onChange) return settings;

    return Object.assign({}, this.args.settings, { onChange: this.#onChange });
  }

  get type(): 'checkbox' | 'radio' {
    return this.args.type === 'radio' ? 'radio' : 'checkbox';
  }

  get #onChange(): ((this: HTMLInputElement) => void) | undefined {
    if (!this.args.settings) return undefined;

    const initialOnChange = this.args.settings.onChange;
    if (!initialOnChange) return undefined;

    // FUI checkbox module calls the onChange callback with `settings.onChange.call(input)`
    // https://github.com/fomantic/Fomantic-UI/blob/910440f6275a7e85e278915dfb4846c88d43f1ba/src/definitions/modules/checkbox.js#L187
    // The callback will not receive any argument, but the context (ie: this), will be the HTMLInputElement
    // and we will get the checked info with `this.checked`
    return function (this: HTMLInputElement) {
      initialOnChange(this.checked);
    };
  }

  <template>
    {{#let (uniqueId) as |id|}}
      {{! @glint-expect-error }}
      <div class={{this.class}} {{fuiCheckbox this.settings}}>
        <input id={{id}} type={{this.type}} checked={{@isChecked}} />
        <label for={{id}}>{{@label}}</label>
      </div>
    {{/let}}
  </template>
}
